
export { default as getTrailLocationName } from "./utils/getTrailLocationName"